import React from 'react';
import { accentFor } from '../../utils/constants';

/** Doctor photo, or a colourful silhouette placeholder when the clinic hasn't uploaded one. */
export default function DoctorPhoto({ src, name }) {
  return (
    <div className={`doctor-photo accent--${accentFor(name)}`}>
      {src ? (
        <img src={src} alt={name} />
      ) : (
        <svg viewBox="0 0 160 140" className="doctor-photo__silhouette" aria-hidden="true">
          <circle cx="80" cy="52" r="30" />
          <path d="M14 140c0-40 30-66 66-66s66 26 66 66z" />
        </svg>
      )}
    </div>
  );
}
